import React from 'react'
import { useField } from 'formik'
import TextField from '@mui/material/TextField'

type CustomProps = {
    name: string
    label : string
    multiline?: boolean
    type: string
    placeholder?: string
    id: string
  } & typeof defaultProps;

const defaultProps = {
  multiline: false,
  placeholder: '',
}

// eslint-disable-next-line max-len
export const InputField = (props: CustomProps) => {
  const [field, meta] = useField(props)
  const {
    placeholder, type, label, multiline,
  } = props
  const errorText = meta.error && meta.touched ? meta.error : ''

  return (
    <TextField
      {...field}
      placeholder={placeholder}
      type={type}
      label={label}
      variant="outlined"
      fullWidth
      helperText={errorText}
      error={!!errorText}
      multiline={multiline}
    />
  )
}

InputField.defaultProps = defaultProps
